@let compact = isCollapsed() && isLgUp();
<section class="pl" aria-labelledby="pl-title">
  @if (!compact) {
  <div class="pl-head">
    <p id="pl-title" class="pl-head__title">Profesionales</p>
    @if (hiddenCount() > 0) {
    <button type="button" class="pl-head__action" (click)="showAll()">Mostrar todos</button>
    } @else if (professionals().length) {
    <span class="pl-head__caption" aria-hidden="true">Citas esta semana</span>
    }
  </div>
  }

  @if (!professionals().length) {
  <p class="pl-empty">
    Aún no tienes profesionales. Agrégalos desde Configuración, en Profesionales.
  </p>
  }

  <ul class="pl-list">
    @for (p of professionals(); track p.userId) {
    @let name = getProfessionalDisplayName(p);
    @let color = p.color ?? '#465FFF';
    <li class="pl-row" [class.pl-row--off]="isHidden(p.userId)" [style.--pro-color]="color">
      <button type="button" role="checkbox" class="pl-toggle" [class.pl-toggle--compact]="compact"
        [attr.aria-checked]="!isHidden(p.userId)"
        [attr.aria-label]="(isHidden(p.userId) ? 'Mostrar' : 'Ocultar') + ' las citas de ' + name"
        [attr.title]="compact ? name : null" (click)="onFilterProfessionals(p.userId)">
        @if (compact) {
        <span class="pl-avatar" aria-hidden="true">{{ initials(p) }}</span>
        } @else {
        <span class="pl-check" aria-hidden="true">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5"
            stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
        </span>
        <span class="pl-name">{{ name }}</span>
        <span class="pl-count" [attr.title]="p.eventCount + (p.eventCount === 1 ? ' cita' : ' citas') + ' esta semana'">
          @if (p.isLoadingCount) { <span class="pl-count__loading"></span> } @else { {{ p.eventCount }} }
        </span>
        }
      </button>
      @if (!compact && professionals().length > 1) {
      <button type="button" class="pl-only" (click)="showOnly(p.userId)"
        [attr.aria-label]="'Ver solo las citas de ' + name">Solo</button>
      }
    </li>
    }
  </ul>
</section>
